<template>
  <div class="content">
    <div class="content-box">
      <div class="administrators—box">
        <div class="content">
          <!-- 步骤条 -->
          <div class="content-main">
            <!-- 管理员信息 -->
            <div class="form-box">
              <el-form :model="administratorsForm" ref="form1" label-position="top">
                <el-form-item :label="$t('crm_partner_item_administrators.glymc')" prop="realName" :rules="rules.realName">
                  <el-input v-model="administratorsForm.realName" :disabled="!!administratorsForm.userId" style="width: 310px"></el-input>
                </el-form-item>
                <!-- :rules="rules.mobile" -->
                <el-form-item :label="$t('crm_partner_item_administrators.glydh')" prop="mobile">
                  <el-input v-model="administratorsForm.mobile" :disabled="!!administratorsForm.userId" style="width: 310px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_partner_item_administrators.glyyx')" prop="email" :rules="rules.email">
                  <el-input v-model="administratorsForm.email" :disabled="!!administratorsForm.userId" style="width: 310px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_partner_item_administrators.deng_lu_ming_cheng')" prop="loginName" v-if="administratorsForm.userId">
                  <el-input autocomplete="off" v-model="administratorsForm.loginName" :disabled="!!administratorsForm.userId" style="width: 310px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_partner_item_administrators.deng_lu_mi_ma')" prop="loginPwd" v-if="!administratorsForm.userId" :rules="rules.loginPwd">
                  <el-input autocomplete="off" :readonly="inputReadonly" type="password" v-model="administratorsForm.loginPwd" style="width: 310px" @focus="inputReadonly = false"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_partner_item_administrators.que_ren_mi_ma')" prop="confirmPwd" v-if="!administratorsForm.userId" :rules="rules.confirmPwd">
                  <el-input autocomplete="off" type="password" :readonly="inputReadonly" v-model="administratorsForm.confirmPwd" style="width: 310px" @focus="inputReadonly = false"></el-input>
                </el-form-item>
                <el-form-item key="timeZoneId" :label="$t('crm_partner_item_administrators.mo_ren_shi_qu')" :rules="type === 'factory' ? rules.timeZoneId : []" v-if="timeZoneList.length > 1">
                  <custom-select
                    v-model="administratorsForm.timeZoneId"
                    :data="timeZoneList"
                    :auto="false"
                    :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"
                    style="width: 310px"
                  ></custom-select>
                </el-form-item>
                <el-form-item key="dateFormat" :label="$t('crm_partner_item_administrators.rqxsgs')" :rules="type === 'factory' ? rules.dateFormat : []">
                  <custom-select v-model="administratorsForm.dateFormat" code="bas_date_format" width="310px"></custom-select>
                </el-form-item>
                <el-form-item key="isTime24h" :label="$t('crm_partner_item_administrators.24xiao_shi_zhi')" :rules="type === 'factory' ? rules.isTime24h : []">
                  <!-- <el-switch v-model="administratorsForm.isTime24h" :active-value="1" :inactive-value="0"></el-switch> -->
                  <custom-select v-model="administratorsForm.isTime24h" code="isynergy_cloud_bool" :placeholder="$t('Common.com_please_select')" style="width: 310px"></custom-select>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="$emit('previousinfo')" v-if="enterpriseType === 5">{{ $t('crm_partner_item_administrators.sybjbxx') }}</el-button>
      <el-button @click="$emit('previous')" v-else>{{ $t('crm_partner_item_administrators.sybszlxr') }}</el-button>
      <el-button type="primary" @click="saveAdministrators">{{ $t('Common.com_finish') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    partnerId: [String, Number],
    enterpriseType: [String, Number],
    type: [String],
  },
  data() {
    return {
      inputReadonly: true,
      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      businessLicenseImageList: [],
      imageList: [],
      imageIdList: [],
      timeZoneList: [],
      administratorsForm: {
        organId: '', // 服务租赁方id
        organType: 'CS', // 类型 服务租赁方
        loginName: '',
        realName: '',
        mobile: '',
        email: '',
        loginPwd: '',
        confirmPwd: '',
        userId: null,
        timeZoneId: '',
        dateFormat: '',
        isTime24h: '',
      },

      // 租赁方ID
      companyId: '',
      // 管理员ID
      organId: '',
      organType: '',
    };
  },
  mounted() {
    // this.companyId = this.getJump('companyId');
    this.companyId = this.partnerId || '';
    this.getCompanyDetail();
    this.rules.loginPwd[1].validator = (rule, value, callback) => {
      const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
      if (!reg.test(value.toString())) {
        callback(new Error());
      } else {
        callback();
      }
    };
    this.rules.confirmPwd[0].validator = (rule, value, callback) => {
      if (value !== this.administratorsForm.loginPwd) {
        callback(new Error());
      } else {
        callback();
      }
    };
    this.rules.mobile[1].validator = this.$mobilePhoneValidator;
  },

  computed: {
    rules() {
      return {
        // 管理员
        realName: [
          { type: 'string', required: true, message: this.$t('crm_partner_item_administrators.qtxglyxm') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        mobile: [
          { required: true, message: this.$t('crm_partner_item_administrators.qtxlxrdh') },
          {
            validator: null,
            message: this.$t('crm_partner_item_administrators.cdyz713gzf'),
          },
        ],
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('crm_partner_item_administrators.yxgsbzq'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        loginName: [
          {
            required: true,
            min: 4,
            max: 20,
            message: this.$t('crm_partner_item_administrators.cdyz420gzfxszmszzf'),
          },
          {
            validator: null,
            message: this.$t('crm_partner_item_administrators.bxsszzmzfzdzh'),
          },
        ],
        loginPwd: [
          {
            required: true,
            min: 8,
            max: 16,
            message: this.$t('crm_partner_item_administrators.cdyz816gzfszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('crm_partner_item_administrators.bxbhszfhzmrylz'),
          },
        ],
        confirmPwd: [{ required: true, validator: null, message: this.$t('crm_partner_item_administrators.lcsrmmbyz') }],
        timeZoneId: { required: true, message: this.$t('Common.com_required') },
        dateFormat: { required: true, message: this.$t('Common.com_required') },
        isTime24h: { required: true, message: this.$t('Common.com_required') },
      };
    },
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.companyId) {
        this.getTimeZoneList(true);
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.companyId }).then((res) => {
        this.organId = res.data.partnerOrgId;
        this.partnerType = res.data.partnerType;
        this.getAdminItem();
        this.getTimeZoneList(false);
      });
    },

    getAdminItem: function () {
      this.$getJSON(`${apis.partnerOrganAdminItem}/${this.organId}`).then((res) => {
        if (res.data) {
          this.administratorsForm = res.data;
        }
      });
    },
    // 获取时区列表
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneList = res.data;
        if (this.timeZoneList.length > 0 && isInit && this.type === 'factory') {
          this.administratorsForm.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    // 保存管理员
    saveAdministrators: function () {
      this.administratorsForm.mobile = this.administratorsForm.mobile.replace(/\s+/g, '');
      if (this.administratorsForm.userId) {
        // 修改保存
        // this.$emit('jumpOut');
        this.$refs.form1.validate((valid) => {
          if (!valid) {
            return;
          }
          const regx = /^[0-9\-]{7,13}$/g;
          if (this.administratorsForm.mobile && !regx.test(this.administratorsForm.mobile)) {
            this.$message.error(this.$t('crm_partner_item_administrators.dhcdyz713gzf'));
            return;
          }
          this.administratorsForm.organId = this.organId; // 管理员id
          this.administratorsForm.organType = this.partnerType; // 管理员类型
          // 新增保存
          this.$postJSON(apis.UserUpdate, this.administratorsForm).then((res) => {
            // 有返回值代表成功
            if (res) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });

              this.$emit('jumpOut');
            }
          });
          // this.saveAddCompany();
        });
      } else {
        this.$refs.form1.validate((valid) => {
          if (!valid) {
            return;
          }
          const regx = /^[0-9\-]{7,13}$/g;
          if (this.administratorsForm.mobile && !regx.test(this.administratorsForm.mobile)) {
            this.$message.error(this.$t('crm_partner_item_administrators.dhcdyz713gzf'));
            return;
          }
          this.administratorsForm.organId = this.organId; // 管理员id
          this.administratorsForm.organType = this.partnerType; // 管理员类型
          // 新增保存
          this.$postJSON(apis.partnerOrganAdmin, {
            ...this.administratorsForm,
            loginPwd: this.encrypt(this.administratorsForm.loginPwd),
            confirmPwd: this.encrypt(this.administratorsForm.confirmPwd),
          }).then((res) => {
            // 有返回值代表成功
            if (res) {
              this.$message({
                message: this.$t('Common.com_add_success'),
                type: 'success',
              });

              this.$emit('jumpOut');
            }
          });
          // this.saveAddCompany();
        });
      }
    },
  },
};
</script>

<style lang="scss">
// @import "../../../../style/colors.scss";

.renter-item-bd {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background: #fff;
  // .header-step {
  //   flex: 0 0 80px;
  //   padding: 20px 0;
  // }
  // 步骤条
  .steps {
    display: flex;
    flex: 0 0 80px;
    padding: 20px 0;
    width: 1200px;
    margin: 0 auto 40px;
    overflow: hidden;
    .steps-item {
      flex: 1;
      .steps-item-head {
        position: relative;
        width: 100%;
        color: #8c8c8c;
        border-color: #8c8c8c;
        text-align: center;
        .line {
          position: relative;
          border-color: inherit;
          background-color: #d3d3d3;
          width: 100%;
          .line-left {
            left: 0;
            // right: -50%;
            height: 2px;
            top: 11px;
            position: absolute;
            border-color: inherit;
            background-color: #d3d3d3;
            background-color: inherit;
            width: 50%;
          }
          .line-rigth {
            // left: 50%;
            left: 50%;
            height: 2px;
            top: 11px;
            position: absolute;
            border-color: inherit;
            background-color: #d3d3d3;
            background-color: inherit;
            width: 50%;
          }
        }
        .icon {
          position: relative;
          z-index: 1;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          font-size: 14px;
          box-sizing: border-box;
          background: #eff0f3;
          transition: 0.15s ease-out;
          border-radius: 50%;
          border: 1px solid;
          border-color: inherit;
          color: #999;
        }
      }
      .steps-item-main {
        text-align: center;
        .title {
          margin-top: 15px;
          color: #999;
        }
      }
    }
    .steps-item.on {
      flex: 1;
      .steps-item-head {
        color: #00afff;
        border-color: #00afff;
        .line {
          background-color: #00afff;
        }
        .icon {
          background: #00afff;
          color: #fff;
        }
      }
      .steps-item-main {
        text-align: center;
        .title {
          margin-top: 15px;
          color: #999;
        }
      }
    }
    .steps-item:first-of-type {
      .line {
        .line-left {
          display: none;
        }
      }
    }
    .steps-item:last-of-type {
      .line {
        .line-rigth {
          display: none;
        }
      }
    }
  }
  .content-wrap {
    // height: 100%;
    // width: 1100px;
    // margin: 0 auto;
    // display: flex;
    background-color: #ffffff;
    position: relative;
    flex: 1;
    justify-content: center;
    // overflow: auto;
  }
  .info-box,
  .contacts-box,
  .administrators—box {
    // display: flex;
    width: 100%;
    // flex-direction: column;

    .content {
      flex: 1;
      display: flex;
      width: 1100px;
      margin: 0 auto;
      // .title {
      //   line-height: 24px;
      //   font-size: 16px;
      //   padding-left: 10px;
      //   position: relative;
      //   color: #262626;
      //   margin:0 0 24px;
      //   .tag {
      //     width: 4px;
      //     height: 15px;
      //     background-color: #00afff;
      //     left: 0;
      //   }
      // }
      .servericeCompany-step {
        flex: 0 0 250px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        padding: 44px 0 0 44px;
        .step-box {
          width: 24px;
          flex-direction: column;
          align-items: center;
        }
        .bar {
          background-color: #1890ff;
          width: 2px;
          flex: 0 0 48px;
        }
        .step {
          position: relative;
          padding: 0 5px;
          &.cur h1 {
            background-color: #1890ff;
          }
          h1 {
            margin: 0 auto;
            width: 24px;
            height: 24px;
            color: #ffffff;
            border-radius: 50%;
            background-color: #bebebe;
            line-height: 24px;
            text-align: center;
            font-size: 14px;
          }
          p {
            color: #595959;
            font-size: 14px;
            line-height: 24px;
            left: 36px;
          }
        }
      }
      .content-main {
        padding: 30px;
        flex: 1;
        .title-top {
          line-height: 24px;
          font-size: 16px;
          padding-left: 10px;
          position: relative;
          color: #595959;
          margin-bottom: 30px;
          .tag {
            width: 4px;
            height: 15px;
            background-color: #00afff;
            left: 0;
          }
        }
        .business-form,
        .finance-form,
        .other-form {
          // margin-bottom: 30px;

          .title {
            line-height: 16px;
            font-size: 16px;
            position: relative;
            color: #262626;
            padding: 30px 0 20px 10px;
            margin-bottom: 30px;
            .tag {
              width: 4px;
              height: 15px;
              background-color: #00afff;
              left: 0;
            }
          }

          .role-list {
            margin-bottom: 30px;
            ul {
              // padding: 30px 0 0px;
              border: 1px solid #e4e4e4;
              li {
                margin-top: 10px;
                background: #fff;
                border: 0;
                &:first-child {
                  margin-top: 0;
                  background: whitesmoke;
                }
              }
            }

            .item {
              height: 50px;
              padding: 10px;
              // background: rgba(245, 245, 245, 1);
              // border: 1px solid rgba(228, 228, 228, 1);
              // line-height: 30px;
              font-size: 12px;
              .icon-box {
                line-height: 30px;
                width: 30px;
                margin-left: 10px;
                text-align: center;
                cursor: pointer;
                .icon {
                  color: #00afff;
                  font-size: 14px;
                }
              }
            }
            .formContact-title {
              height: 40px;
            }
          }
          .formContact-title {
            height: 40px;
          }
        }
        .role-add-btn {
          background: whitesmoke;
          border: 1px solid #e4e4e4;
          line-height: 40px;
          text-align: center;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
          margin-bottom: 30px;
          cursor: pointer;
          .icon {
            color: #00afff;
            font-size: 10px;
            margin-right: 8px;
            float: left;
          }
        }
      }
    }
    .btn-group {
      // position: absolute;
      border-top: 1px solid rgba(0, 0, 0, 0.05);
      padding-top: 18px;
      // bottom: 0;
      height: 70px;
      // left: 250px;
      // right: 0;
      text-align: center;
      background-color: #f4f4f4;
      z-index: 1;
      flex: 0 0 70px;
      width: 100%;
    }
  }
  // .servericeCompany-wrap {
  //   flex: 1;
  //   padding: 40px 60px 110px;
  //   overflow-y: auto;
  //   position: relative;
  //   .el-upload-list--picture-card .el-upload-list__item {
  //     height: 80px;
  //     width: 80px;
  //     line-height: 80px;
  //   }
  //   .el-upload--picture-card {
  //     height: 80px;
  //     width: 80px;
  //     line-height: 88px;
  //   }
  //   .tip {
  //     background: rgba(254, 252, 238, 1);
  //     border: 1px solid rgba(230, 162, 60, 1);
  //     line-height: 30px;
  //     font-size: 13px;
  //     color: #262626;
  //     margin-top: 20px;
  //     .icon {
  //       color: #e6a23c;
  //       font-size: 12px;
  //       float: left;
  //       margin: 0 10px;
  //     }
  //   }
  //   .title {
  //     line-height: 24px;
  //     font-size: 16px;
  //     padding-left: 10px;
  //     position: relative;
  //     color: #595959;

  //     .tag {
  //       width: 4px;
  //       height: 15px;
  //       background-color: #00afff;
  //       left: 0;
  //     }
  //   }
  //   .form-box {
  //     padding: 32px 0;
  //     .el-upload__tip {
  //       color: #757575;
  //     }
  //   }
  // }

  .limit-pic .el-upload--picture-card {
    display: none;
  }
}
</style>
